import './Contract.scss'
import { UHCTemplateContractProps, ContractCloud, ServerCatalogResponse, ImagesResponse } from 'uh-ui-cloud-material';
import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';

import { QUERY_IMAGES, QUERY_SERVERCATALOG } from './Contract.grapqhl';
import { getGroupQueryParam, getStatusByHookGraphql, removeCompute512MB } from './Contract.service';

const priceGroup = getGroupQueryParam(window.location) || null

export function Contract() {
    const [statusPage, setStatusPage] = useState<UHCTemplateContractProps['status']>('loading')
    
    const hardwareQueryResponse = useQuery<ServerCatalogResponse>(QUERY_SERVERCATALOG, {
        variables: { priceGroup },
    })
      
    const imagesQueryResponse = useQuery<ImagesResponse>(QUERY_IMAGES)
    
    useEffect(() => {
        setStatusPage(getStatusByHookGraphql(imagesQueryResponse, hardwareQueryResponse))        

        return () => {setStatusPage('loading')}
    }, [imagesQueryResponse, hardwareQueryResponse])

    const modifiedHardwareQueryData = removeCompute512MB(hardwareQueryResponse?.data)

    return <ContractCloud hardwareQueryResponse={modifiedHardwareQueryData}
                          imagesQueryResponse={imagesQueryResponse?.data}
                          statusPage={statusPage}
                          priceGroup={priceGroup} />    
}